/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Split_Hint_Full_BodyInputs */

const en_us2_profile_editors_split_hint_full_body = /** @type {(inputs: Profile_Editors_Split_Hint_Full_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every workout trains the whole body.`)
};

const pt_br2_profile_editors_split_hint_full_body = /** @type {(inputs: Profile_Editors_Split_Hint_Full_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todo treino trabalha o corpo inteiro.`)
};

const es_419_profile_editors_split_hint_full_body = /** @type {(inputs: Profile_Editors_Split_Hint_Full_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada entrenamiento trabaja todo el cuerpo.`)
};

const pt_pt2_profile_editors_split_hint_full_body = /** @type {(inputs: Profile_Editors_Split_Hint_Full_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada treino trabalha o corpo inteiro.`)
};

const fr_fr2_profile_editors_split_hint_full_body = /** @type {(inputs: Profile_Editors_Split_Hint_Full_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaque séance travaille tout le corps.`)
};

const de_de2_profile_editors_split_hint_full_body = /** @type {(inputs: Profile_Editors_Split_Hint_Full_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jedes Training trainiert den ganzen Körper.`)
};

const it_it2_profile_editors_split_hint_full_body = /** @type {(inputs: Profile_Editors_Split_Hint_Full_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogni allenamento lavora tutto il corpo.`)
};

/**
* | output |
* | --- |
* | "Every workout trains the whole body." |
*
* @param {Profile_Editors_Split_Hint_Full_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_split_hint_full_body = /** @type {((inputs?: Profile_Editors_Split_Hint_Full_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Split_Hint_Full_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_split_hint_full_body(inputs)
	if (locale === "es-419") return es_419_profile_editors_split_hint_full_body(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_split_hint_full_body(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_split_hint_full_body(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_split_hint_full_body(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_split_hint_full_body(inputs)
	return en_us2_profile_editors_split_hint_full_body(inputs)
});
export { profile_editors_split_hint_full_body as "profile-editors.split_hint_full_body" }